import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';
import {WebDesignComponent} from "../services/descriptionComponents/web-design.component";
import {NgForm} from "@angular/forms";
import {HttpService} from "../http.service";
import {ContactFormSmallComponent} from "../homepage/contact-form-small.component";

@Component({
  selector: 'app-faq-content',
  templateUrl: './faq-content.component.html',
  styleUrls: ['./faq-content.component.css']
})
export class FaqContentComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.416;

  constructor(private service: GlobalServiceService, private httpService: HttpService) { }

  ngOnInit(){
    this.onResize();
    this.slider();
    $('.first').addClass('activeSlider');
    ContactFormSmallComponent.hidePopup();
  }

  onResize(){
    let width = $('.wrapper').width();
    this.height = this.service.getHeight(this.proportion);
      if (width < $(window).height()) {
        let header = $("#header").height();
        let footer = $("#footer").height();
        let result = $(window).height() - header - footer - this.height;
        $(".plug").css("height", result);
      }
  }

  onSubmit(form: NgForm) {
    let url = 'http://creativedigitalmailserver.us-west-2.elasticbeanstalk.com/mail?name=' + form.value.name.toString() + '&email='
      + form.value.email.toString() + '&phone=' + form.value.phone.toString() + '&budget=' + form.value.message.toString();
    this.httpService.sendOrder(url).subscribe(
      data => ContactFormSmallComponent.processSuccess(data.status.toString()),
      err => ContactFormSmallComponent.processFail(err)
    );
  }


  slider () {
    let slider = $('.slider');
    $('.first').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.fifth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.six').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.seven').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.eight').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.nine').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/faq/faq-content.component.ts